import { RootState } from "@/store/store";
import { savingsOpportunitiesSelectedRowsIdsSelector } from "@/store/savings-opportunities/selectors/selection/savingsOpportunitiesSelectedRowsIdsSelector";
import { aiKubernetesRecommendationsSelector } from "@/store/ai-kubernetes-recommendations/selectors/aiKubernetesRecommendationsSelector";

export const aiKubernetesRecommendationsSelectedItemsSelector = (
  state: RootState,
) => {
  const ids = savingsOpportunitiesSelectedRowsIdsSelector(state);
  const data = aiKubernetesRecommendationsSelector(state);

  return data?.filter((savingsOpportunity) =>
    ids.includes(savingsOpportunity.id),
  );
};
